import { Hub } from '@sentry/browser';
import { CaptureConsole } from '@sentry/integrations';
import { debugMessage } from '../debugMessage';

export class S4MPCaptureConsole {
  public static id: string = 'S4MPCaptureConsole';
  public name: string = S4MPCaptureConsole.id;
  private _hub: Hub;
  options: ConstructorParameters<typeof CaptureConsole>[0];

  constructor(
    hub: Hub,
    httpOptions: ConstructorParameters<typeof CaptureConsole>[0],
  ) {
    this._hub = hub;
    this.options = httpOptions;
  }

  setupOnce() {
    debugMessage('sentry: setting up S4MPCaptureConsole integration');
    new CaptureConsole(this.options).setupOnce(
      () => {},
      () => this._hub,
    );
  }
}
